import React, { useEffect, useState, useRef } from 'react';
import { pushToHistory } from './ToastHistoryModal';
import { getEmptyMessage, messageTypes } from '../../utils/MessageUtils';
import AppWebSocket, { ReadyState } from '../AppWebSocket/AppWebSocket';
import ConnectionBanner from '../ConnectionBanner/ConnectionBanner';

/**
 * props:
 * - type
 * - text
 * - listenMessages
 */
function Toast(props) {
    const DEFAULT_NOTIFICATION = getEmptyMessage();

    const [notification, setNotification] = useState(DEFAULT_NOTIFICATION);
    const [wsState, setWsState] = useState(ReadyState.UNINSTANTIATED);
    const notyfRef = useRef(null);

    function getNotyf() {
        if (!notyfRef.current) {
            notyfRef.current = new window.Notyf({
                position: { x: 'right', y: 'top' },
                duration: 5000,
                dismissible: true,
                ripple: false,
                types: [
                    { type: messageTypes.INFO,    background: 'blue',  duration: 6000, dismissible: true },
                    { type: messageTypes.ERROR,   background: 'red',   duration: 0,    dismissible: true },
                    { type: messageTypes.SUCCESS, background: 'green', duration: 5000, dismissible: true }
                ]
            });
        }
        return notyfRef.current;
    }

    useEffect(() => {
        if (!notification.text) return;

        // Se /vendor/notyf não carregou (ex.: rede caiu no load), window.Notyf é undefined e o
        // `new` lançava dentro do effect — derrubava a árvore React inteira (tela branca).
        // Sem a lib, o aviso só vai pro histórico e pro console.
        if (typeof window.Notyf === 'function') {
            getNotyf().open({
                type: notification.type,
                message: notification.text
            });
        } else {
            console.warn('[Toast] Notyf indisponível:', notification.text);
        }
        pushToHistory(notification);

        setNotification(DEFAULT_NOTIFICATION);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notification]);

    useEffect(() => {
        setNotification({ type: props.type, text: props.text });
    }, [props.type, props.text]);

    function onAppNotification(notification) {
        setNotification(notification);
    }

    return (
        <React.Fragment>
            {
                props.listenMessages === false
                ? <React.Fragment></React.Fragment>
                : (
                    <React.Fragment>
                        <AppWebSocket onNotification={onAppNotification} onStateChange={setWsState} />
                        <ConnectionBanner readyState={wsState} />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}

export default Toast;
